import { mapActions, mapGetters } from 'vuex';
import localStorage from '@/components/Services/storage';
import { RESEND_COUNTDOWN_DURATION, SMS_STATE_KEY } from '@/constants/auth';

export default {
    data() {
        return {
            smsCode: '',
            countdown: RESEND_COUNTDOWN_DURATION,
            countdownInterval: null,
        };
    },

    computed: {
        ...mapGetters({
            user: 'user/user',
        }),
        realSmsCode() {
            // TODO PROVERITI DAL RADI OVO ISPOD
            if ('OTPCredential' in window) {
                navigator.credentials.get({
                    otp: { transport: ['sms'] },
                }).then((otp) => otp.code);
            }
        },
        isResendDisabled() {
            return this.countdown > 0;
        },
        formattedCountdown() {
            const minutes = Math.floor(this.countdown / 60);
            const seconds = this.countdown % 60;
            return `${minutes}:${seconds.toString().padStart(2, '0')}`;
        },
    },

    methods: {
        ...mapActions('user', ['loginViaSms', 'attemptToGetSmsCodeViaMsisdn']),
        handleLogin() {
            this.loginViaSms({ code: this.smsCode, userId: this.user.userId })
                .then(() => {
                    // Only clear on successful login
                    if (this.countdownInterval) {
                        clearInterval(this.countdownInterval);
                        this.countdownInterval = null;
                    }
                    localStorage.remove(SMS_STATE_KEY);
                })
                .catch(() => {
                    // Keep SMS state on failed login - user can retry
                    // Error already handled by Vuex action
                });
        },
        resendSmsCode() {
            const phoneNumber = this.user.phoneNumber || localStorage.get('phone', true);

            // Validate phone number exists
            if (!phoneNumber) {
                this.$toast.error(this.$t('pages.login.errors.phoneNumberMissing'));
                return;
            }

            this.attemptToGetSmsCodeViaMsisdn({ phone: phoneNumber })
                .then(() => {
                    // Only reset countdown on successful SMS send
                    this.countdown = RESEND_COUNTDOWN_DURATION;
                    this.startCountdown();
                })
                .catch(() => {
                    // Show user-friendly error message
                    this.$toast.error(this.$t('pages.login.errors.resendFailed'));
                    // Don't reset countdown - user can try again immediately
                });
        },
        startCountdown() {
            if (this.countdownInterval) {
                clearInterval(this.countdownInterval);
            }
            this.countdownInterval = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    clearInterval(this.countdownInterval);
                }
            }, 1000);
        },
    },

    mounted() {
        this.$refs.smsLoginInput.focus();

        // Check if there's a recent SMS send timestamp
        const smsStateStr = localStorage.get(SMS_STATE_KEY, true);
        if (smsStateStr) {
            try {
                const smsState = JSON.parse(smsStateStr);
                const elapsedSeconds = Math.floor((Date.now() - smsState.lastSentTime) / 1000);
                const remainingSeconds = RESEND_COUNTDOWN_DURATION - elapsedSeconds;
                this.countdown = Math.max(0, remainingSeconds);
            } catch (e) {
                // Invalid JSON, ignore and start fresh
                console.error('Failed to parse SMS state:', e);
            }
        }

        this.startCountdown();
    },

    beforeDestroy() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
    },
};
